export default __webpack_public_path__ + "static/media/14.bcd27224.jpeg";